import React from 'react'

import { Form } from 'antd';
import Cache from '../../frame/Cache';
import { Input, InputGroup, Icon } from 'rsuite';

import Config from '../../config/Config'
import WidgetAjax from '../../widget/WidgetAjax';
import WidgetModal from '../../widget/WidgetModal';
import WidgetTable from '../../widget/WidgetTable';
import WidgetMessage from '../../widget/WidgetMessage';
import WidgetTreePicker from '../../widget/WidgetTreePicker';
import WidgetComponent from './../../widget/WidgetComponent';


import 'antd/dist/antd.css';
import './css/system.css';

class userDomain extends WidgetComponent 
{

    constructor( props )
    {
        super(props);

        let path = Config.getBasePath();

        if( path.endsWith('/')===false )
        {
            path = path + '/';
        }

        let userInfo = sessionStorage.getItem("_user_info_");

        if( userInfo!==undefined && userInfo!==null )
        {
            userInfo = JSON.parse(userInfo);
        }

        this.state = {
            userInfo:userInfo,
            path : path,
            keyWord : undefined,
            data : undefined,
            total : undefined,
            options : {
                records : 15
            },
            columns:[
                { name: 'id', title: '角色领域id', type: 'string', description: '角色领域id', properties: { hidden: true }},
                { name: 'parent_id', title: '上级角色领域id', type: 'string', description: '上级角色领域id', properties: { hidden: true }},
                { name: 'name', title: '角色领域名称', type: 'string', description: '角色领域名称', properties: { hidden: false }},
                // { name: 'parent_name', title: '上级分组名称', type: 'string', description: '上级分组名称', properties: { hidden: false }},
                { name: 'remark', title: '领域备注', type: 'string', description: '领域备注', properties: { hidden: false }},
                { name: 'operation', title: '操作', type: 'string', description: '操作', 
                    properties: {hidden: false, 
                        operations: [
                            { name: '编辑', click: "departmentEdit" },
                            { name: '删除', click: "departmentRemove"}
                        ]
                    }
                }
            ],
            editDepartmentModelOptions : {
                title : "创建用户领域",
                confirm : "确定",
                size : 'md'
            },
            departmentData : undefined, 
            department : {},
            removeDepartment : {

            },
            layout : {
                labelCol: { span: 6 },
                wrapperCol: { span: 16 },
            },
            messageOptions : {
                title : "信息",
            },
            filterBankData:undefined,
            flag:false
        };
        
        this.onEvent = this.onEvent.bind(this);
        
        this.pageTurning = this.pageTurning.bind(this);
        this.keyWordKeyUp = this.keyWordKeyUp.bind(this);
        this.inputOnchange = this.inputOnchange.bind(this);
        this.removeConfirm = this.removeConfirm.bind(this);
        this.keyWordOnChange = this.keyWordOnChange.bind(this);
        this.createDepartment = this.createDepartment.bind(this);
        this.departmentSearch = this.departmentSearch.bind(this);
        this.removeDepartment = this.removeDepartment.bind(this);
       
        this.submitDepartment = this.submitDepartment.bind(this);
        this.onDepartmentSearch = this.onDepartmentSearch.bind(this);
        this.onSubmitDepartment = this.onSubmitDepartment.bind(this);
        this.onRemoveDepartment = this.onRemoveDepartment.bind(this); 

        this.buildDepartmentData = this.buildDepartmentData.bind(this); 

        
    }
    componentDidMount()
    {
        this.departmentSearch(1);
    }

    /**
     * 把子组件注入到父主键里
     * @param {*} ref 
     */
    editDepartmentModelRef = (ref) => {

        this.editDepartmentModelRef =  ref ;
    }

    messageRef = ( ref ) => {
        this.messageRef = ref;
    }

    
    buildDepartmentData( data, parent)
    {
        let items = [];

        for( let i=0; i<data.length; i++ )
        {
            let node = {};
            
            node.role = parent;
            node.label = data[i].name;
            node.id = data[i].id;
            node.value = data[i].id;

            if( data[i].subdepartments !== undefined )
            {
                node.children = this.buildDepartmentData(data[i].subdepartments, data[i].id);
            }
            
            items.push(node);
        }

        return items;
    }

    

    /**
     * 部门信息input值变化触发函数
     * @param {*} value 
     * @param {*} type 
     */
    inputOnchange( value, type )
    {
        switch( type )
        {
            case "name":
            {
                this.state["departmentName"] = value;
                break;
            }
            case "remark":
            {
                this.state["departmentRemark"] = value;
                break;
            }
            default:
                break;
        }
    }

    /**
     * 创建组件
     */
    createDepartment()
    {
        this.state["isCreate"] = true;
        let {editDepartmentModelOptions} = this.state

        this.setState({department:{}, departmentId:undefined });
        editDepartmentModelOptions.title = "新增用户领域"
        this.editDepartmentModelRef.open();
    }

    /**
     * 编辑部门
     */
    editDepartment( data )
    {
        this.state["isCreate"] = false;
        let {editDepartmentModelOptions} = this.state
        
        if( data!==undefined )
        {
            if( data.parent_id!==undefined )
            {
                data["defaultValues"] = [];

                data["defaultValues"].push(data.parent_id);
            }
          
            this.setState({department:data, departmentId: data.id});
        }
        editDepartmentModelOptions.title = "编辑用户领域"

        this.editDepartmentModelRef.open();
    }

    /**
     * 创建部门，编辑部门确定函数
     */
    submitDepartment()
    {
        const { departmentId, departmentName, departmentRemark, path, isCreate, department,userInfo } = this.state;
        let params = {
            name : departmentName||department.name,
            remark :departmentRemark||department.remark
        }

        if( departmentId!==undefined && departmentId!==null) 
        { 
            params["id"] = departmentId;
        }

        if( isCreate )
        {
            WidgetAjax.ajax({url:path + 'realm/create', params:params, callback:this.onSubmitDepartment});
        }
        else
        {
            WidgetAjax.ajax({url:path + 'realm/update', params:params, callback:this.onSubmitDepartment});
        }
    }

    /**
     * 部门添加/修改回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onSubmitDepartment( result, params )
    {
        let { messageOptions, isCreate } = this.state;

        messageOptions["isMessage"] = true ;

        if( result.status===0 )
        {
            if( isCreate )
            {
                messageOptions["message"] = "用户领域 '" + params.name +"' 创建成功！" ;
            }
            else
            {
                messageOptions["message"] = "用户领域 '" + params.name +"' 修改成功！" ;
            }

            this.departmentSearch(1);

            this.messageRef.open();
        }
        else
        {
            if( isCreate )
            {
                messageOptions["message"] = "用户领域 '" + params.name +"' 创建失败！" ;
            }
            else
            {
                messageOptions["message"] = "用户领域 '" + params.name +"' 修改失败！" ;
            }
            this.departmentSearch(1);

            this.messageRef.open();
        }
    }

    /**
     * 删除部门
     * @param {*} data 
     */
    removeDepartment( data )
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false ;
        messageOptions["message"] = `确定要删除用户领域 '` + data.name +`' 吗? 删除后，记录将不能恢复！` ;
        messageOptions["confirmFunction"] = this.removeConfirm;
        
        this.state["removeDepartment"] = data;

        this.state["messageOptions"] = messageOptions;

        this.messageRef.open();
    }

    /**
     * 删除确认函数
     */
    removeConfirm()
    {
        const { path, removeDepartment } = this.state;


        if( removeDepartment!==undefined )
        {
            let params = {
                id : removeDepartment.id,
                name: removeDepartment.name
            }
    
            WidgetAjax.ajax({url:path + 'realm/remove', params:params, callback:this.onRemoveDepartment});
        }
    }

    /**
     * 部门删除回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onRemoveDepartment( result, params )
    {
        let  { messageOptions } = this.state;

        if( result.status===0 )
        {
            messageOptions["message"] = "用户领域 '" + params.name +"' 删除成功！" ;
            messageOptions["title"] = "信息";
            messageOptions["isMessage"] = true;
            this.setState({messageOptions})
        }
        else
        {
            messageOptions["message"] = "用户领域 '" + params.name +"' 删除失败！" ;
            messageOptions["title"] = "信息";
            messageOptions["isMessage"] = true;
            this.setState({messageOptions})
        }

        
        this.departmentSearch(1);

        this.messageRef.open();
    }


    /**
     * 搜索关键字变化回调函数 
     * @param {*} value 
     * @param {*} event 
     */
    keyWordOnChange(value, event)
    {
        this.setState({keyWord:value});
    }

    /**
     * 键盘事件捕获
     * @param {*} e 
     */
    keyWordKeyUp( e )
    {
        /** 判断是否是回车事件 */
        if( e.keyCode===13 )
        {
            this.departmentSearch();
        }
    }

    /**
     * 部门搜索函数
     */
    departmentSearch( page )
    {
        const { path, keyWord, options,userInfo } = this.state;

        if( page===undefined )
        {
            page = 1;
        }

        let params = {
            page : page,
            records : options.records
        };

        if( keyWord!==undefined && keyWord!==null && keyWord!=="")
        {
            params["name"] = keyWord;
        }
        WidgetAjax.ajax({url:path + 'realm/search', params:params, callback:this.onDepartmentSearch});
    }

    /**
     * 部门搜索回调函数
     * @param {*} result 
     * @param {*} params 
     */
    onDepartmentSearch( result, params )
    {
        if( result.status===0 )
        {
            let { options } = this.state;

            options["page"] = params.page;

            this.setState({data:result.results, total:result.total, options:options});
        }
        
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }

    }

    /**
     * 表格翻页
     * @param {*} page 
     */
    pageTurning( page )
    {
        this.departmentSearch(page);
    }

    /**
     * 表格点击事件
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     */
    onEvent(type, data, value, event)
    {
        if( data!==undefined )
        {
            data = JSON.parse(data);
        }

        switch( type )
        {
            case "departmentEdit":
            {
                this.editDepartment(data);
                break;
            }
            case "departmentRemove":
            {
                this.removeDepartment(data);
                break;
            }
            default:
                break;
        }
    }


    render()
    {
        const { columns, data, total, keyWord, options, editDepartmentModelOptions, department, layout, messageOptions, filterBankData,
            defaultValues,flag} = this.state;

        editDepartmentModelOptions["confirmFunction"] = this.submitDepartment;

        return (
            <div className="page DepartmentPage">
                <div className="page-content page-overflow" style={{height:"100%",borderRadius:"0",boxShadow:"none"}}>
                    <div className="content-canvas content-top-frame-height height-100"  style={{borderRadius:"0",boxShadow:"none"}}>
                        <div className="content-title Addroles content-title-addroles">
                            <div className="button"  style={{width:"auto"}}>
                                <span className="addUser click" onClick={this.createDepartment}>新增用户领域</span>
                            </div>
                            <div className="search">
                                <InputGroup className="InputGroup"  >
                                    <Input name="Serchkey" defaultValue={keyWord} placeholder="请输入关键词进行搜索" onChange={this.keyWordOnChange } onKeyUp={this.keyWordKeyUp} />
                                    <InputGroup.Addon><Icon icon="search" onClick={this.departmentSearch} /></InputGroup.Addon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="content-chart-height content-table" style={{marginTop:'0px'}}>
                            <WidgetTable options={options} columns={columns} data={data} total={total} notify={this.onEvent} pageTurning={this.pageTurning}></WidgetTable>
                        </div>
                    </div>
                </div>

                <WidgetModal options={editDepartmentModelOptions} onRef={this.editDepartmentModelRef} >
                    <Form  {...layout} name="basic">
                        <Form.Item label="用户领域名称" name="departmentName">
                            <Input defaultValue={department.name} onChange={(value) => {this.inputOnchange(value, "name")}}></Input>
                        </Form.Item>
                        <Form.Item label="备注" name="remark">
                            <Input componentClass="textarea" defaultValue={department.remark} onChange={(value) => {this.inputOnchange(value, "remark")}}></Input>
                        </Form.Item>
                    </Form>
                </WidgetModal>

                <WidgetMessage options={messageOptions} onRef={this.messageRef} />
          </div>
        );
    }
}

export default userDomain
